import React from "react"
import { Box, Typography } from "@material-ui/core"
import RoomIcon from "@material-ui/icons/Room"
import type { MapaRoteirizacaoProps } from "./tipos"
import { GoogleMapaRoteirizacao } from "./GoogleMapaRoteirizacao"
import { MapboxMapaRoteirizacao } from "./MapboxMapaRoteirizacao"

/**
 * Escolhe o renderizador do mapa conforme a configuração do cliente:
 * MapBox quando `tipoSelecaoEndereco === 2` (e há token), senão Google Maps.
 */
export function MapaRoteirizacao({
    provedor,
    tokenMapbox,
    origem,
    marcadores,
    onSelecionarPedido,
}: MapaRoteirizacaoProps) {
    if (provedor === "mapbox") {
        if (!tokenMapbox) {
            return (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    height="100%"
                    p={3}
                    style={{ textAlign: "center", color: "#7f8c8d" }}
                >
                    <RoomIcon style={{ fontSize: 48, marginBottom: 8 }} />
                    <Typography variant="body1">
                        Mapa indisponível: o token do MapBox não está configurado para este
                        estabelecimento.
                    </Typography>
                </Box>
            )
        }
        return (
            <MapboxMapaRoteirizacao
                origem={origem}
                marcadores={marcadores}
                onSelecionarPedido={onSelecionarPedido}
                token={tokenMapbox}
            />
        )
    }

    return (
        <GoogleMapaRoteirizacao
            origem={origem}
            marcadores={marcadores}
            onSelecionarPedido={onSelecionarPedido}
        />
    )
}
